var map = {
	"./poi_SESUnits.svg": 940,
	"./poi_SESUnits_multi.svg": 941,
	"./poi_ambulance.svg": 942,
	"./poi_ambulance_multi.svg": 943,
	"./poi_emergency.svg": 944,
	"./poi_emergency_multi.svg": 945,
	"./poi_fireStation.svg": 946,
	"./poi_fireStationForest.svg": 947,
	"./poi_fireStationForest_multi.svg": 948,
	"./poi_fireStation_multi.svg": 949,
	"./poi_hospital.svg": 950,
	"./poi_hospital_multi.svg": 951,
	"./poi_marker.svg": 952,
	"./poi_marker_multi.svg": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;